import http from '@/http'
import { PartTags } from '@/interfaces/admin'

export async function getPartTagsByPartId (partId: number): Promise<PartTags> {
  const { data } = await http.get(`/part-tags/admin/by-entity/${partId}`)
  return data
}
